import React, { Component } from 'react'
import { Link } from "react-router-dom";


function openFuncation() {
    var element = document.getElementById("navmobile");
    element.classList.add("show-menu");
  }
  function closeFuncation() {
    var element = document.getElementById("navmobile");
    element.classList.remove("show-menu");
  }

export default class Navbar extends Component {
    constructor() {
        super();
        this.state = {
            active: 'home'
        }
        this._handleClick = this._handleClick.bind(this);
    }

    _handleClick(e) {
         this.setState({
            active: e.target.innerHTML
         });
    }

    render() {
        let flights;
        let Hotels;
        let movies;
        let cars;
        let cruises;
        let insurance;
        let tourspackage;
        let holidays;

        if (this.state.active === 'Home') {
            flights = { color: '#f82249' };
            Hotels = {};
            movies = {};
            cars = {};
            cruises = {};
            insurance = {};
            tourspackage = {};
            holidays = {};
        } 
        else if (this.state.active === 'Hotels') {
            flights = {};
            Hotels = { color: '#f82249'};
            movies = {};
            cars = {};
            cruises = {};
            insurance = {};
            tourspackage = {};
            holidays = {};
        } 
         else if (this.state.active === 'Movies') {
            flights = {};
            Hotels = {};
            movies = { color: '#f82249'};
            cars = {};
            cruises = {};
            insurance = {};
            tourspackage = {};
            holidays = {};
        } 
         
          else if (this.state.active === 'Cars') {
            flights = {};
            Hotels = {};
            movies = {};
            cars = { color: '#f82249'};
            cruises = {};
            insurance = {};
            tourspackage = {};
            holidays = {};
        } 
          else if (this.state.active === 'Cruises') {
            flights = {};
            Hotels = {};
            movies = {};
            cars = {};
            cruises = {color: '#f82249'};
            insurance = {};
            tourspackage = {};
            holidays = {};
        } 
         else if (this.state.active === 'Insurance') {
            flights = {};
            Hotels = {};
            movies = {};
            cars = {};
            cruises = {};
            insurance = { color: '#f82249'};
            tourspackage = {};
            holidays = {};
        } 
         else if (this.state.active === 'Tours Package') {
            flights = {};
            Hotels = {};
            movies = {};
            cars = {};
            cruises = {};
            insurance = {};
            tourspackage = { color: '#f82249'};
            holidays = {};
        } 
         else if (this.state.active === 'Holidays') {
            flights = {};
            Hotels = {};
            movies = {};
            cars = {};
            cruises = {};
            insurance = {};
            tourspackage = {};
            holidays = {color: '#f82249'};
        } 
        
        else {
            flights = {color: '#f82249'};
            movies = {};
             Hotels = {};
            movies = {};
            cars = {};
            cruises = {};
            insurance = {};
            tourspackage = {};
            holidays = {};
        }

        return (
         <>
    <nav className="navbar navdesign navbar-expand-lg navigation_design fixed-top">
        <div className="container-fluid">
          <a className="navbar-brand deals_text" href="#">Big Saving on Cheap Flights Prices!</a>
    

          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav mx-auto">
              <li className="nav-item"><a className="nav-link ison_certyfied" href="/top-airlines">Top Airlines</a></li>
              <li className="nav-item"><a className="nav-link ison_certyfied" href="/top-destinations">Top Destination</a></li>
              <li className="nav-item"><a className="nav-link ison_certyfied" href="/contact-us.html">Customer Support</a></li>
              <li className="nav-item"><a className="nav-link deals_link" href="/deals"><span className="bg-deals"></span> Deals</a></li>
              <li className="nav-item"><a className="nav-link ison_certyfied" href="/gift-card">Gift Card</a></li>
              <li className="nav-item"><a className="nav-link ison_certyfied" href="/blog">Blog</a></li>
            </ul>
          </div>

          <div className="social-icons">
            <a href="https://twitter.com/prices_cheap" className="twitter"><i className="bi bi-twitter"></i></a>
            <a href="https://www.facebook.com/Cheapflightsprices/" className="facebook"><i className="bi bi-facebook"></i></a>
            <a href="https://www.instagram.com/Cheapflightsprices" className="instagram"><i className="bi bi-instagram"></i></a>
            <a href="https://in.pinterest.com/Cheapflightsprices" className="pinterest"><i className="bi bi-pinterest"></i></a>
            <a href="https://www.linkedin.com/company/cheap-flights-prices/" className="linkedin"><i className="bi bi-linkedin"></i></a>
          </div>
        </div>
      </nav>
          <nav className="navbar navbar-expand-lg navbar-light">
           <i className="bi bi-list mobile-nav-toggle" onClick={openFuncation}></i>

    <ul className="navbar-nav nav-center navmobile" id="navmobile" onClick={closeFuncation}>
      <i className="bi bi-x-lg closebtn" onClick={closeFuncation}></i>

      <li className="nav-item">
        <Link className="nav-link" style={flights} onClick={this._handleClick}  to="/">Home</Link>
      </li>
      <li className="nav-item">
        <Link className="nav-link" style={Hotels}  onClick={this._handleClick} to="hotels.html">Hotels</Link>
      </li>
      <li className="nav-item">
        <Link className="nav-link" style={movies} onClick={this._handleClick} to="movies">Movies</Link>
      </li>
      <li className="nav-item">
        <Link className="nav-link" style={cars} onClick={this._handleClick} to="cars.html">Cars</Link>
      </li>

      <li className="nav-item">
        <Link className="nav-link" style={cruises} onClick={this._handleClick} to="cruises.html">Cruises</Link>
      </li>
      <li className="nav-item">
        <Link className="nav-link" style={insurance} onClick={this._handleClick} to="insurance">Insurance</Link>
      </li>
      
      <li className="nav-item">
        <Link className="nav-link" style={tourspackage} onClick={this._handleClick} to="tours-package">Tours Package</Link>
      </li>
        <li className="nav-item">
        <Link className="nav-link" style={holidays} onClick={this._handleClick} to="holidays.html">Holidays</Link>
      </li>
     {/*
       <li className="nav-item">
        <Link className="nav-link" style={holidays} onClick={openNav}>Holidays</Link>
      </li>
     */}
      <ul className="nav navbar-nav navbar-right call_center_exe">
 
 <li className="top_chat"> <p className="book_now">Book Now!</p>
 <p className="chat_suport_now">Get the Support  24/7</p></li>
 <li className="call_executive"><a href="mailto:cheapflightsprices@gmail.com"><img src={"../assets/img/cheapflights.jpg"} /></a></li>

 </ul>
    </ul>
</nav>
        </>
        )
    }
}